import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { Driver } from '../../store/ducks/freight/types';

export interface GetPrivateDriversResponse {
  page: number;
  rows: Driver[];
  totalRecords: number;
  startDate?: string;
  endDate?: string;
}

export default function useGetPrivateDrivers() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page: number;
    rowsPerPage?: number;
    searchFilter?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<GetPrivateDriversResponse | undefined> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/private-drivers', {
        params: {
          rowsPerPage: params.rowsPerPage || 10,
          page: params.page,
          searchFilter: params.searchFilter,
          status: params.status !== 'Todos' ? params.status : undefined,
          startDate: params.startDate,
          endDate: params.endDate,
        },
      });

      return response.data;
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.genericError);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}

